// extracted by mini-css-extract-plugin
export default {"pageContainer":"app_pageContainer__dls1l"};